<app-alerts />

@if (form$ | async; as form) {
  <div class="flex flex-col gap-8">
    <app-admin-brand-details-form
      [isEditContext]="true"
      [uploadFn]="uploadFn"
      (submitClickEvent)="handleSubmitClickEvent($event)"
      [data]="form" />

    <div class="mt-10">
      <app-admin-brand-banner-management
        [brandId]="id()"
        (changedEvent)="handleBannerChangedEvent()" />
    </div>
  </div>
} @else {
  <app-spinner-filled />
}
